import { render } from "./Developments2.vue?vue&type=template&id=4b2fe009&scoped=true"
import script from "./Developments2.vue?vue&type=script&lang=js"
export * from "./Developments2.vue?vue&type=script&lang=js"

import "@/assets/css/topicContent.sass?vue&type=style&index=0&id=4b2fe009&lang=sass&scoped=true"
import "./Developments2.vue?vue&type=style&index=1&id=4b2fe009&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2fe009"]])

export default __exports__